export const SAVE_MEDICAL_NOTES_REQUEST = "SAVE_MEDICAL_NOTES_REQUEST";
export const SAVE_MEDICAL_NOTES_SUCCESS = "SAVE_MEDICAL_NOTES_SUCCESS";
export const SAVE_MEDICAL_NOTES_ERROR = "SAVE_MEDICAL_NOTES_ERROR";
